export enum ContactRelation {
  PATIENT = 'PATIENT',
  SPOUSE = 'SPOUSE',
  FAMILY_MEMBER = 'FAMILY_MEMBER',
  OTHER = 'OTHER',
}
